import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import useCommonFetch from "../../../../hooks/useCommonFetch";
import { createLeave, getLeaveList, updateLeave, updateLeavePost } from "../../../../services/workspace/leave.service";
import CommonTable from "../../../components/table/table";
import BottomDrawer from "../../common/drawer/bottomDrawer";
import CommonForm from "../../../components/form/form";
import LeaveDetail from "../../hr/staffLeave/components/leaveDetail";
import { getLeaveTypeList } from "../../../../services/workspace/leaveType.service";
import { getUserList } from "../../../../services/workspace/user.service";
import toast from "react-hot-toast";
import { convertToLabelValue } from "../../../../utils/common";
import DefaultSearchSelectInput from "../../../components/inputs/defaultSearchSelectInput";

export const items = [{ label: "Apply Leave", path: "" }];

const ApplyLeave = () => {
  const [isEditValue, setIsEditValue] = useState(null);
  const [isOpenSheet, setIsOpenSheet] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [leaveSheet, setLeaveSheet] = useState(false);
  const [leaveTypeList, setLeaveTypeList] = useState([]);
  const [leaveTypeLoading, setLeaveTypeLoading] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [staffList, setStaffList] = useState([]);
  const [staffLoading, setStaffLoading] = useState(false);
  const [calculatedDays, setCalculatedDays] = useState(0);
  const [dynamicFields, setDynamicFields] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const formikValuesRef = useRef({});
  const [initialDataSnapshot, setInitialDataSnapshot] = useState({});
  const [userList, setUserList] = useState([]);
  const [selectedLeaves, setSelectedLeaves] = useState([]);
  const { role: userType } = useSelector((state) => state.user);
  const isAdmin = Number(userType) === 0 || Number(userType) === 1;

  const TableHeaderData = [
    ...(isAdmin ? [{ label: "Staff Name", key: "name" }] : []),
    { label: "Leave Type", key: "leave_type" },
    { label: "From Date", key: "start_date" },
    { label: "To Date", key: "end_date" },
    { label: "Total Days", key: "total_days" },
    { label: "Reason", key: "reason" },
    { label: "Status", key: "status" },
  ];

  const data = [
    { label: "Department", value: currentRecord?.department?.data },
    { label: "Designation", value: currentRecord?.designation?.data },
    { label: "Leave Type", value: currentRecord?.leave_type?.data },
    { label: "From Date", value: currentRecord?.start_date?.data },
    { label: "To Date", value: currentRecord?.end_date?.data },
    { label: "Total Days", value: currentRecord?.total_days?.data },
    { label: "Reason", value: currentRecord?.reason?.data },
    { label: "image", value: currentRecord?.user?.image?.data },
    {
      label: "Status",
      value:
        currentRecord?.status?.data === 1
          ? "Approved"
          : currentRecord?.status?.data === 2
          ? "Rejected"
          : "Pending",
    },
    { label: "Staff ID", value: currentRecord?.staff_id?.data },
    { label: "days", value: currentRecord?.days?.data },
    { label: "Remarks", value: currentRecord?.remarks?.data || "N/A" },
  ];

  const comprehensiveFields = [
    // {
    //   name: "user_id",
    //   label: "Select Staff",
    //   type: "select",
    //   placeholder: "Search and select staff member",
    //   required: true,
    //   options: staffList,
    //   colSpan: 12,
    //   disabled: staffLoading,
    //   info: "Select the staff member for whom you want to apply leave. As an admin, you can apply leave on behalf of any employee.",
    //   searchable: true,
    // },
    {
      name: "leave_type_id",
      label: "Leave Type",
      type: "select",
      placeholder: "Select leave type",
      required: true,
      options: leaveTypeList,
      colSpan: 12,
      disabled: leaveTypeLoading,
      info: "Select the type of leave (CL, SL, EL, etc.). Note: Gender-specific leaves (like Maternity) will only be available for eligible employees.",
    },
    {
      name: "start_date",
      label: "From Date",
      type: "date",
      placeholder: "Select start date",
      required: true,
      colSpan: 6,
      onChange: (value) => handleDateChange("start_date", value),
      minDate: new Date(),
      info: "Select the start date of leave. Leave period will be calculated from this date.",
    },
    {
      name: "end_date",
      label: "To Date",
      type: "date",
      placeholder: "Select end date",
      required: true,
      colSpan: 6,
      onChange: (value) => handleDateChange("end_date", value),
      minDate: (values) => {
        // If start_date is selected, end_date should be at least start_date
        if (values.start_date) {
          const start = new Date(values.start_date);
          return start;
        }
        // Otherwise, end_date should be at least today
        return new Date();
      },
      info: "Select the end date of leave. End date should be after start date.",
    },
    {
      name: "reason",
      label: "Reason for Leave",
      type: "textarea",
      placeholder:
        "Enter reason for leave application (e.g., Personal work, Medical emergency, etc.)",
      maxLength: 300,
      colSpan: 12,
      required: true,
      info: "Provide a clear reason for the leave application. This will be visible to approvers.",
    },
  ];

  const {
    data: tableData,
    total: totalData,
    currentPage,
    search,
    handlePageChange,
    closeModal,
    handleCreate,
    handleUpdate,
    fetchData,

    loading,
  } = useCommonFetch(getLeaveList, {
    dataPath: "leave.data",
    totalPath: "leave.meta.total",
    errorMessage: "Failed to fetch leave data!",
    debounceDelay: 500,
    customParams:!isAdmin?{ with: "user,leaveType,days"}: { with: "user,leaveType,days", user_id: "",status:0  },
    filterModule: "leave",
    sortingOptions: [
      { label: "Name", field: "name" },
      { label: "Date", field: "start_date" },
    ],
    sortingModule: "leave",
    orderParamNames: {
      orderByKey: "order_by",
      orderTypeKey: "order_type",
      includeDisabledKey: "includeDisabled",
    },
    sortingDisableText: "Disabled",
    sortingShowDisableToggle: false,
    autoFetch: !isAdmin,

    dataTransformer: (data) => {
      // Use dummy data if no real data available (for design testing)
      // const dataToUse = data && data.length > 0;

      // let userData = dataToUse.map((item) => {
      //   return { value: item.user.id, label: item.user.name };
      // });
      // setUserList(userData);
      const rows = Array.isArray(data) ? data : [];
      const transformedData = rows.map((item) => ({
        id: {
          data: item.id,
          className: "",
          variant: "text",
        },
        uuid: {
          data: item.uuid,
          className: "",
          variant: "text",
        },

        staff_id: {
          data: item.user?.code,
          className: "",
          variant: "text",
        },
        name: {
          data: {
            name: item.user?.name,
            email: item.user?.email,
            image: item.user?.image || "",
            link: `/hr/staff-directory/profile/${item.uuid}`,
            id: item.user?.code,
          },
          className: "",
          sticky: false,
          variant: "profile",
          customCases: null,
        },
        department: {
          data: item.user?.department?.name,
          className: "",
          variant: "text",
        },
        designation: {
          data: item.user?.designation?.name,
          className: "",
          variant: "text",
        },
        leave_type: {
          data: item.leaveType?.name,
          className: "",
          variant: "text",
        },
        start_date: {
          data: item.start_date,
          className: "",
          variant: "date",
        },
        end_date: {
          data: item.end_date,
          className: "",
          variant: "date",
        },
        total_days: {
          data: item.total_days,
          className: "",
          variant: "number",
        },
        reason: {
          data: item.reason,
          className: "",
          variant: "text",
        },
        days: {
          data: null,
          className: "",
          variant: "text",
          dataArray: item.days,
        },
        status: {
          data: item.status,
          className: "",
          variant: "status",
        },
        image: {
          data: item.user?.image || "",
          className: "",
          variant: "image",
        },
        remarks: {
          data: item.remarks || "",
          className: "",
          variant: "text",
        },
      }));

      const actionButton = {
        view: (item) => {
          setIsOpenSheet(true);
          setIsEditMode(false);
          setCurrentRecord(item);
        },
        quickApprove: (item) => {
          if (item.status?.data === 0) {
            handleApprove(item.uuid.data, { status: 1 });
          }
        },
        quickReject: (item) => {
          if (item.status?.data === 0) {
            handleReject(item.uuid.data, { status: 2 });
          }
        },
      };

      return {
        data: transformedData,
        action: actionButton,
      };
    },
  });

  // Fetch staff list for admin (for page-level filtering)
  useEffect(() => {
    if (!isAdmin) return;
    setStaffLoading(true);
    getUserList({})
      .then((response) => {
        const users = response?.user?.data || [];
        setStaffList(convertToLabelValue(users) || []);
        setStaffLoading(false);
      })
      .catch((error) => {
        toast.error("Failed to fetch staff list!");
        console.error(error);
        setStaffLoading(false);
      });
  }, [isAdmin]);

  // Refetch table when admin selects staff
  useEffect(() => {
    if (!isAdmin) return;
    
    // useCommonFetch will merge this into request params
    // eslint-disable-next-line react-hooks/exhaustive-deps
    fetchData({ user_id: "",status:0 }, true);
  }, []);
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    // Validate required fields
    // if (!values.user_id) {
    //   toast.error("Please select a staff member");
    //   setSubmitting(false);
    //   return;
    // }
    if (!values.leave_type_id) {
      toast.error("Please select a leave type");
      setSubmitting(false);
      return;
    }

    if (!values.start_date || !values.end_date) {
      toast.error("Please select both start and end dates");
      setSubmitting(false);
      return;
    }

    if (new Date(values.end_date) < new Date(values.start_date)) {
      toast.error("End date must be after start date");
      setSubmitting(false);
      return;
    }

    if (!values.reason || !values.reason.trim()) {
      toast.error("Please provide a reason for leave");
      setSubmitting(false);
      return;
    }

    // Update form values state
    setFormValues(values);

    // Check if dynamic fields are present in values
    const dynamicFieldNames = [];
    for (let i = 1; i <= calculatedDays; i++) {
      dynamicFieldNames.push(`day_${i}`, `date_${i}`);
    }

    // Validate that all dynamic fields are filled if days are calculated
    if (calculatedDays > 0) {
      const missingFields = [];
      for (let i = 1; i <= calculatedDays; i++) {
        if (!values[`day_${i}`]) {
          missingFields.push(`Day ${i} type`);
        }
      }

      if (missingFields.length > 0) {
        toast.error(`Please fill in: ${missingFields.join(", ")}`);
        setSubmitting(false);
        return;
      }
    }

    // Process dynamic day values
    const processedValues = { ...values };

    // Extract day and date values and format them properly
    const days = [];

    for (let i = 1; i <= calculatedDays; i++) {
      const dayType = values[`day_${i}`];
      const dateValue = values[`date_${i}`];

      if (dayType && dateValue) {
        // Convert day type to the required format
        let typeValue;
        switch (dayType) {
          case "full":
            typeValue = "1.0";
            break;
          case "half":
            typeValue = "0.5";
            break;
          case "quarter":
            typeValue = "0.25";
            break;
          default:
            typeValue = "1.0";
        }

        days.push({
          date: dateValue,
          type: typeValue,
          is_paid: 1,
        });
      }
    }

    // Add processed values to the submission
    processedValues.days = days;

    // Edit
    if (isEditValue) {
      const result = await handleUpdate(processedValues, isEditValue.id, updateLeave, {
        successMessage: "Leave updated successfully!",
        errorMessage: "Failed to update leave!",
      });
      
      if (!result?.success) {
        setSubmitting(false);
        return;
      }
    } else {
      // Create new
      const result = await handleCreate(processedValues, createLeave, {
        successMessage: "Leave created successfully!",
        errorMessage: "Failed to create leave!",
      });
      
      if (!result?.success) {
        setSubmitting(false);
        return;
      }
    }

    setSubmitting(false);
    // Reset form after submission
    setTimeout(() => {
      resetForm();
      setIsEditValue();
      setCalculatedDays(0);
      setDynamicFields([]);
      setFormValues({});
      setStartDate("");
      setEndDate("");
      setInitialDataSnapshot({});
      formikValuesRef.current = {};
      setLeaveSheet(false);
    }, 1000);
  };

  // Handle form cancellation
  const handleCancel = () => {
    setIsEditValue(null);
    closeModal();
    setCalculatedDays(0);
    setDynamicFields([]);
    setFormValues({});
    setStartDate("");
    setEndDate("");
    setInitialDataSnapshot({});
    formikValuesRef.current = {};
    setLeaveSheet(false);
  };

  // Calculate days between two dates
  const calculateDays = (startDate, endDate) => {
    if (!startDate || !endDate) return 0;

    const start = new Date(startDate);
    const end = new Date(endDate);

    // Calculate difference in milliseconds
    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // Add 1 to include both start and end dates
    return diffDays + 1;
  };

  // Generate dynamic fields based on calculated days
  const generateDynamicFields = (days) => {
    if (days <= 0) return [];

    const fields = [];
    const startDateObj = new Date(startDate);

    // Add section header
    fields.push({
      name: "leave_day_details_header",
      type: "section_header",
      label: "Leave Day Details",
      colSpan: 12,
    });

    for (let i = 0; i < days; i++) {
      const currentDate = new Date(startDateObj);
      currentDate.setDate(startDateObj.getDate() + i);
      const dateString = currentDate.toISOString().split("T")[0]; // YYYY-MM-DD format
      const displayDateString = currentDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

      fields.push(
        {
          name: `date_${i + 1}`,
          label: `Date ${i + 1}`,
          type: "text",
          placeholder: "Date",
          required: false,
          colSpan: 6,
          disabled: true,
          initialValue: dateString,
        },
        {
          name: `day_${i + 1}`,
          label: `Day ${i + 1} Type`,
          type: "select",
          placeholder: "Select Day Type",
          required: true,
          colSpan: 6,
          initialValue: "full",
          options: [
            { label: "Full Day", value: "full" },
            { label: "Half Day", value: "half" },
            { label: "Quarter Day", value: "quarter" },
          ],
          info: "Full Day = 1 day, Half Day = 0.5 days, Quarter Day = 0.25 days",
        }
      );
    }
    return fields;
  };

  // Handle date changes and recalculate days automatically
  const handleDateChange = (fieldName, value) => {

    // Use the new value directly instead of relying on state
    const newStartDate = fieldName === "start_date" ? value : startDate;
    const newEndDate = fieldName === "end_date" ? value : endDate;

    if (fieldName === "start_date") {
      setStartDate(value);
    } else if (fieldName === "end_date") {
      setEndDate(value);
    }

    // Check if both dates are available and generate fields automatically
    // Use the new values directly instead of state
    if (newStartDate && newEndDate) {
      const days = calculateDays(newStartDate, newEndDate);
      setCalculatedDays(days);

      // BEFORE regenerating, snapshot current form values
      setInitialDataSnapshot({ ...formikValuesRef.current });

      // Generate dynamic fields
      const newDynamicFields = generateDynamicFields(days);
      setDynamicFields(newDynamicFields);
    } else if (fieldName === "start_date" && newEndDate) {
      // If start date changed and end date exists
      const days = calculateDays(value, newEndDate);
      setCalculatedDays(days);

      // Snapshot current form values
      setInitialDataSnapshot({ ...formikValuesRef.current, start_date: value });

      // Generate dynamic fields
      const newDynamicFields = generateDynamicFields(days);
      setDynamicFields(newDynamicFields);
    } else if (fieldName === "end_date" && newStartDate) {
      // If end date changed and start date exists
      const days = calculateDays(newStartDate, value);
      setCalculatedDays(days);

      // Snapshot current form values
      setInitialDataSnapshot({ ...formikValuesRef.current, end_date: value });

      // Generate dynamic fields
      const newDynamicFields = generateDynamicFields(days);
      setDynamicFields(newDynamicFields);
    } else {
      // Clear fields if dates are not complete
      setCalculatedDays(0);
      setDynamicFields([]);
    }
  };

  const fetchLeaveType = () => {
    setLeaveTypeLoading(true);
    getLeaveTypeList()
      .then((response) => {
        setLeaveTypeLoading(false);
        setLeaveTypeList(
          convertToLabelValue(response.leaveType.data || []) || []
        );
      })
      .catch((error) => {
        toast.error("Failed to fetch leave type data!");
      });
  };

  // const fetchStaff = () => {
  //   setStaffLoading(true);
  //   getUserList()
  //     .then((response) => {
  //       setStaffLoading(false);
  //       setStaffList(convertToLabelValue(response.user?.data || []) || []);
  //     })
  //     .catch((error) => {
  //       toast.error("Failed to fetch staff data!");
  //       console.log(error);
  //       setStaffLoading(false);
  //     });
  // };

  const handleApprove = async (id, payload) => {
    const payload2 = {
      status: 1,
      leave_id: id,
      ...payload,
    };
     
    await handleCreate(payload2, updateLeavePost, {
      successMessage: "Leave Approved successfully!",
      errorMessage: "Failed to approve leave!",
    });
    // await handleUpdate(id, payload, updateLeave, {
    //   successMessage: "Leave Approved successfully!",
    //   errorMessage: "Failed to approve leave!",
    // });
    setIsOpenSheet(false);
    fetchData({ user_id: "",status:0 }, true);
  };

  const handleReject = async (id, payload ) => {
    const payload2 = {
      status: 2,
      leave_id: id,
      ...payload,
    };
    await handleCreate(payload2, updateLeavePost, {
      successMessage: "Leave Rejected successfully!",
      errorMessage: "Failed to reject leave!",
    });
    setIsOpenSheet(false);
    fetchData({ user_id: "",status:0 }, true);
  };

  // // Bulk approval/rejection handlers
  // const handleBulkApprove = async () => {
  //   if (selectedLeaves.length === 0) {
  //     toast.error("Please select at least one leave to approve");
  //     return;
  //   }

  //   try {
  //     const promises = selectedLeaves.map((leave) =>
  //       handleUpdate(leave.uuid, { status: 1 }, updateLeave, {
  //         successMessage: "",
  //         errorMessage: "",
  //       })
  //     );
  //     await Promise.all(promises);
  //     toast.success(`${selectedLeaves.length} leave(s) approved successfully!`);
  //     setSelectedLeaves([]);
  //     setBulkActionType(null);
  //   } catch (error) {
  //     toast.error("Failed to approve some leaves");
  //   }
  // };

  // const handleBulkReject = async () => {
  //   if (selectedLeaves.length === 0) {
  //     toast.error("Please select at least one leave to reject");
  //     return;
  //   }

  //   if (!bulkRejectionNotes.trim()) {
  //     toast.error("Please provide rejection notes");
  //     return;
  //   }

  //   try {
  //     const promises = selectedLeaves.map((leave) =>
  //       handleUpdate(
  //         leave.uuid,
  //         { status: 2, remarks: bulkRejectionNotes },
  //         updateLeave,
  //         {
  //           successMessage: "",
  //           errorMessage: "",
  //         }
  //       )
  //     );
  //     await Promise.all(promises);
  //     toast.success(`${selectedLeaves.length} leave(s) rejected successfully!`);
  //     setSelectedLeaves([]);
  //     setBulkActionType(null);
  //     setBulkRejectionNotes("");
  //   } catch (error) {
  //     toast.error("Failed to reject some leaves");
  //   }
  // };

  const handleSelectLeave = (leave) => {
    setSelectedLeaves((prev) => {
      const leaveUuid = leave?.uuid?.data ?? leave?.uuid;
      if (!leaveUuid) return prev;

      const exists = prev.some((l) => l.uuid === leaveUuid);
      if (exists) {
        return prev.filter((l) => l.uuid !== leaveUuid);
      }

      return [...prev, { uuid: leaveUuid, ...leave }];
    });
  };

  // const handleSelectAll = (allLeaves = []) => {
  //   if (!allLeaves || allLeaves.length === 0) {
  //     setSelectedLeaves([]);
  //     return;
  //   }
  //   const pendingLeaves = allLeaves.filter(
  //     (leave) => leave.status?.data === 0
  //   );
  //   if (selectedLeaves.length === pendingLeaves.length && pendingLeaves.length > 0) {
  //     setSelectedLeaves([]);
  //   } else {
  //     setSelectedLeaves(
  //       pendingLeaves.map((leave) => ({
  //         uuid: leave.uuid?.data,
  //         ...leave,
  //       }))
  //     );
  //   }
  // };

  useEffect(() => {
    fetchLeaveType();
  }, []);

  // Watch for date changes and generate dynamic fields automatically
  useEffect(() => {
    if (startDate && endDate) {
      const days = calculateDays(startDate, endDate);
      setCalculatedDays(days);
      // Snapshot current form values before regenerating
      setInitialDataSnapshot({ ...formikValuesRef.current });
      // Generate dynamic fields
      const newDynamicFields = generateDynamicFields(days);
      setDynamicFields(newDynamicFields);
    }
  }, [startDate, endDate]);

  const STATUS_OPTIONS = [
    { label: "Pending", value: "0" },
    { label: "Approved", value: "1" },
    { label: "Rejected", value: "2" },
  ];

  // Get user role from Redux state
  // const { role: userType } = useSelector((state) => state.user);
  // Hide add button for admin (userType 1 = Workspace Admin, 0 = Super Admin)
  const showAddButton = userType !== 1 && userType !== 0;

  return (
    <div className={"flex flex-col gap-2"}>
      <PageTableHeader
        breadcrumbs={items}
        add={showAddButton}
        onClickAdd={() => setLeaveSheet(true)}
      />

      {/* Admin: page-level staff selector (like Leave Summary) */}
      {/* {isAdmin && (
        <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
          <div className="flex flex-col gap-2">
            <label className="text-gray-700 font-medium text-sm">
              Select Staff <span className="text-red-600">*</span>
            </label>
            <DefaultSearchSelectInput
              options={staffList}
              value={selectedStaff}
              onChange={(sel) => setSelectedStaff(sel)}
              placeholder="Search and select staff member"
              isDisabled={staffLoading}
              className="w-full"
            />
            {!selectedStaff && (
              <p className="text-sm text-gray-500">
                Please select a staff member to view leave requests
              </p>
            )}
          </div>
        </div>
      )} */}

      <CommonTable
        search={search}
        TableHeaderData={[
          // {
          //   label: (
          //     <input
          //       type="checkbox"
          //       checked={
          //         tableData?.data &&
          //         tableData.data.length > 0 &&
          //         tableData.data
          //           .filter((item) => item.status?.data === 0)
          //           .every((item) =>
          //             selectedLeaves.some((l) => l.uuid === item.uuid?.data)
          //           )
          //       }
          //       onChange={() => handleSelectAll(tableData?.data || [])}
          //       className="cursor-pointer"
          //     />
          //   ),
          //   key: "select",
          //   className: "w-12",
          // },
          ...TableHeaderData,
        ]}
        tabledata={(tableData?.data || []).map((item) => ({
          ...item,
          select: {
            data: (
              <input
                type="checkbox"
                checked={selectedLeaves.some((l) => l.uuid === item.uuid?.data)}
                onChange={() => {
                  if (item.status?.data === 0) {
                    handleSelectLeave(item);
                  }
                }}
                disabled={item.status?.data !== 0}
                className="cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              />
            ),
            variant: "custom",
          },
        }))}
        currentPage={currentPage}
        totalData={totalData}
        setCurrentPage={handlePageChange}
        loading={loading}
        action={tableData?.action}
      />

      <BottomDrawer
        size={"500px"}
        title="Leave Details"
        isOpen={isOpenSheet}
        position="right"
        setIsOpen={setIsOpenSheet}
      >
        <LeaveDetail
          currentRecord={currentRecord}
          data={data}
          handleApprove={handleApprove}
          handleReject={handleReject}
        />
      </BottomDrawer>

      <BottomDrawer
        size={"md"}
        title="Add Leave"
        isOpen={leaveSheet}
        position="right"
        setIsOpen={setLeaveSheet}
      >
        {/* Instructions */}
        <div className="mb-4 p-3 bg-information-50 border border-information-200 rounded-lg">
          <p className="font-semibold text-theme mb-2 flex items-center gap-2">
            <span>📝</span> Apply Leave on Behalf of Staff
          </p>
          <p className="text-sm text-theme mb-3">
            As an admin, you can apply leave for any staff member. Follow these
            steps:
          </p>
          <ol className="list-decimal list-inside space-y-1 text-sm text-textLight text-xs">
            <li>
              <strong>Select Staff:</strong> Choose the employee for whom you
              want to apply leave
            </li>
            <li>
              <strong>Select Leave Type:</strong> Choose the appropriate leave
              type (CL, SL, EL, etc.)
            </li>
            <li>
              <strong>Select Dates:</strong> Choose start and end dates. Day
              fields will be generated automatically
            </li>
            <li>
              <strong>Configure Days:</strong> For each day, select the type
              (Full Day, Half Day, or Quarter Day)
            </li>
            <li>
              <strong>Enter Reason:</strong> Provide a clear reason for the
              leave application
            </li>
            <li>
              <strong>Submit:</strong> Review and submit the leave application
            </li>
          </ol>
          <div className="mt-3 p-2 bg-warning-50 border border-warning-200 rounded">
            <p className="text-xs text-theme">
              <strong>Note:</strong> The leave will be applied with "Pending"
              status and will require approval from the designated approver.
            </p>
          </div>
        </div>

        <CommonForm
          fields={[...comprehensiveFields, ...dynamicFields]}
          initialData={isEditValue ? isEditValue : initialDataSnapshot}
          onValuesChange={(vals) => {
            formikValuesRef.current = vals;
            setFormValues(vals);
          }}
          onSubmit={handleSubmit}
          submitButtonText={isEditValue ? "Update Leave" : "Apply Leave"}
          onCancel={handleCancel}
          cancelButtonText="Cancel"
          gap="gap-4"
          rowClassName=""
          fieldClassName="bg-white p-3 rounded border border-borderColor"
        />

        {/* Summary Section */}
        {calculatedDays > 0 && startDate && endDate && (
          <div className="mt-4 p-4 bg-success-50 border border-success-200 rounded-lg">
            <p className="text-sm font-semibold text-theme mb-2">
              Leave Summary
            </p>
            <div className="grid grid-cols-2 gap-2 text-sm text-textLight">
              <div>
                <span className="font-medium">Total Days:</span>{" "}
                {calculatedDays} day(s)
              </div>
              <div>
                <span className="font-medium">Period:</span> {startDate} to{" "}
                {endDate}
              </div>
            </div>
          </div>
        )}
      </BottomDrawer>
    </div>
  );
};

export default ApplyLeave;
